import React from "react";
import { Footer } from "../../../../CommonComponents/footer";
import UpvcVariantSubComp from "./upvcVariantsubPages";

const UpvcVariantPage = () => {

  return (
    <>
      <UpvcVariantSubComp/>
      <br /><br />
      <Footer />
    </>
  );
};

export default UpvcVariantPage;




